document.addEventListener("DOMContentLoaded", function () {
  // ---------------------------------------------------------
  // 1. 无限循环 + 拖拽 + 速度控制逻辑
  // ---------------------------------------------------------
  const viewports = document.querySelectorAll('.slider-viewport');

  viewports.forEach(viewport => {
    const track = viewport.querySelector('.slider-track');
    if (!track) return;

    // A. 克隆元素
    const originalItems = Array.from(track.children);
    if (originalItems.length === 0) return;

    // 复制两份以确保大屏上也不会露馅
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add('cloned');
      track.appendChild(clone);
    });

    // B. 状态变量
    let isDragging = false;
    let isHovering = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationId = null;
    
    // 从 Liquid 设置中读取参数
    const baseSpeed = parseFloat(viewport.dataset.speed) || 0.5;
    const pauseOnHover = viewport.dataset.pause === 'true';

    // 计算宽度
    let singleSetWidth = 0;
    
    function calculateWidths() {
      const firstItem = originalItems[0];
      if(!firstItem) return;
      
      const itemWidth = firstItem.offsetWidth;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 20;
      singleSetWidth = (itemWidth + gap) * originalItems.length;
    }
    
    // 初始化计算 & 监听窗口变化
    calculateWidths();
    window.addEventListener('resize', calculateWidths);

    // C. 核心动画循环 (Singleton Loop)
    function animate() {
      // 只有在非拖拽状态下才自动滚动
      if (!isDragging) {
        // 如果开启了悬停暂停，且鼠标悬停中，则速度为 0
        if (pauseOnHover && isHovering) {
          // do nothing, speed effectively 0
        } else {
          currentTranslate -= baseSpeed;
        }
      }

      // 边界检查 (无限循环核心)
      if (singleSetWidth > 0) {
        if (currentTranslate <= -singleSetWidth) {
          currentTranslate += singleSetWidth;
          prevTranslate = currentTranslate; // 修正拖拽基点
        } else if (currentTranslate > 0) {
          currentTranslate -= singleSetWidth;
          prevTranslate = currentTranslate;
        }
      }

      // 应用位移
      track.style.transform = `translateX(${currentTranslate}px)`;

      // 递归调用
      animationId = requestAnimationFrame(animate);
    }

    // 启动动画 (只启动一次！)
    if (animationId) cancelAnimationFrame(animationId);
    animationId = requestAnimationFrame(animate);

    // D. 事件监听 (Update state only)
    
    function touchStart(event) {
      isDragging = true;
      viewport.classList.add('active');
      startX = getPositionX(event);
    }

    function touchMove(event) {
      if (!isDragging) return;
      
      const currentX = getPositionX(event);
      const diff = currentX - startX;
      
      // 直接修改 currentTranslate，主循环会渲染它
      currentTranslate = prevTranslate + diff;
    }

    function touchEnd() {
      isDragging = false;
      viewport.classList.remove('active');
      prevTranslate = currentTranslate; // 记录松手时的位置
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    // 绑定 Mouse/Touch 事件
    viewport.addEventListener('mousedown', touchStart);
    viewport.addEventListener('touchstart', touchStart, { passive: true });

    viewport.addEventListener('mousemove', touchMove);
    viewport.addEventListener('touchmove', touchMove, { passive: true });

    viewport.addEventListener('mouseup', touchEnd);
    viewport.addEventListener('mouseleave', () => {
      isDragging = false;
      viewport.classList.remove('active');
      prevTranslate = currentTranslate;
      isHovering = false; // 鼠标离开视窗
    });
    viewport.addEventListener('touchend', touchEnd);
    
    // 悬停状态监听
    viewport.addEventListener('mouseenter', () => { isHovering = true; });

    // 防止图片拖拽
    viewport.querySelectorAll('img').forEach(img => img.addEventListener('dragstart', e => e.preventDefault()));
  });


  // ---------------------------------------------------------
  // 2. Modal 逻辑
  // ---------------------------------------------------------
  const modal = document.getElementById("reviewModal");
  const modalClose = document.getElementById("modalClose");
  const modalRating = document.getElementById("modalRating");
  const modalUserInfo = document.getElementById("modalUserInfo");
  const modalContent = document.getElementById("modalContent");
  const modalImages = document.getElementById("modalImages");
  
  const STAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 21" fill="none"><path d="M10.1288 0.545575C10.5114 -0.13307 11.4886 -0.13307 11.8712 0.545574L14.5841 5.35886C14.7268 5.61204 14.9726 5.79061 15.2575 5.84809L20.6735 6.94089C21.4372 7.09497 21.7392 8.02441 21.2119 8.59792L17.4726 12.6655C17.2759 12.8794 17.182 13.1684 17.2154 13.4571L17.8497 18.9458C17.9392 19.7196 17.1485 20.2941 16.4402 19.9699L11.4162 17.6705C11.1519 17.5495 10.8481 17.5495 10.5838 17.6705L5.55982 19.9699C4.85146 20.2941 4.06083 19.7196 4.15027 18.9458L4.78461 13.4571C4.81797 13.1684 4.72409 12.8794 4.52741 12.6655L0.788051 8.59792C0.260824 8.02441 0.562819 7.09497 1.32645 6.94089L6.74251 5.84809C7.0274 5.79061 7.27318 5.61204 7.41588 5.35886L10.1288 0.545575Z" fill="#FA590E" /></svg>`;

  function escapeHtml(text) { if (typeof text !== "string") return ""; const div = document.createElement("div"); div.textContent = text; return div.innerHTML; }
  
  function generateStars(rating) {
    const normalizedRating = Math.max(0, Math.min(5, parseInt(String(rating), 10) || 0));
    const stars = Array.from({ length: 5 }, function (_, i) {
      const isFilled = i < normalizedRating;
      return `<span class="star ${isFilled ? "filled" : "empty"}">${STAR_SVG}</span>`;
    }).join("");
    return `<div class="stars">${stars}</div>`;
  }

  function getUserInfoTemplate(customer) { return `<div class="modal-user-details"><div class="modal-user-name-row"><span class="modal-user-name">${escapeHtml(customer || "")}</span><span class="modal-verified-badge">Verified</span></div></div>`; }
  
  // 修改点：增强空值判断
  function generateUserInfo(customer, avatar) {
    const escapedCustomer = escapeHtml(customer || "");
    const initial = escapedCustomer.charAt(0).toUpperCase();
    // 只有 avatar 存在且不是 "undefined" 字符串时才显示图片
    if (avatar && avatar !== "undefined" && avatar !== "") {
      return `<img loading="lazy" src="${escapeHtml(avatar)}" alt="${escapedCustomer}" class="modal-avatar">${getUserInfoTemplate(customer)}`;
    }
    return `<div class="modal-avatar" style="background: #FA590E; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 600; font-size: 18px;">${initial}</div>${getUserInfoTemplate(customer)}`;
  }

  // 修改点：增强空值判断
  function generateImages(previewImg) {
    if (previewImg && previewImg !== "undefined" && previewImg !== "") {
      return `<img loading="lazy" src="${escapeHtml(previewImg)}" alt="Review image" class="modal-image">`;
    }
    return "";
  }

  function openModal(reviewData) {
    if (!modal) return;
    if (modalRating) modalRating.innerHTML = generateStars(reviewData.rating);
    if (modalUserInfo) modalUserInfo.innerHTML = generateUserInfo(reviewData.customer, reviewData.avatar);
    if (modalContent) modalContent.textContent = reviewData.reviewContent;
    if (modalImages) modalImages.innerHTML = generateImages(reviewData.previewImg);
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeModal() { if (modal) { modal.classList.remove("active"); document.body.style.overflow = ""; } }

  document.addEventListener("click", function (e) {
    const activeViewport = document.querySelector('.slider-viewport.active');
    if (activeViewport) return; // 正在拖拽时不打开
    if (!e.target) return;
    const target = e.target;
    if (typeof target.closest !== "function") return;
    const reviewItem = target.closest(".review-item");
    if (!reviewItem) return;

    // 修改点：使用 getAttribute 获取原始值，避免 dataset 的 undefined 问题
    openModal({
      reviewContent: reviewItem.dataset.reviewContent || "",
      customer: reviewItem.dataset.customer || "",
      rating: reviewItem.dataset.rating || "0",
      avatar: reviewItem.getAttribute('data-avatar') || "", 
      previewImg: reviewItem.getAttribute('data-preview-img') || ""
    });
  }, true);

  if (modalClose) modalClose.addEventListener("click", closeModal);
  if (modal) modal.addEventListener("click", (e) => { if (e.target === modal) closeModal(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && modal && modal.classList.contains("active")) closeModal(); });
});